<template>
    <div class="add-que-box">
        <div class="stem xy-start">
            <div class="row-title">试题题干:</div>
            <varied-input
                ref="question"
                class="auto-grow"
                :input-content.sync="queData.Content"
            ></varied-input>
            <div class="box"></div>
        </div>
        <div v-if="queType === SubjectType.single || queType === SubjectType.multiple">
            <div
                class="row xy-start"
                v-for="(option, index) in queData.AnswerList"
                :key="option.uuid"
            >
                <div class="row-title">
                    选项{{ String.fromCharCode(65 + index) }}:
                </div>

                <varied-input
                    ref="content"
                    :input-content.sync="option.Content"
                    class="auto-grow"
                ></varied-input>
                <div
                    @click="deleteOption(index)"
                    :class="{ 'vis-hidden': queData.AnswerList.length === 2 }"
                    class="box el-icon-close delete-icon"
                ></div>
            </div>

            <div class="row xy-center jf-start">
                <div class="xy-center jf-start">
                    <div class="row-title">正确答案:</div>
                    <el-radio-group
                        v-if="queType === 1"
                        v-model="queData.Answer"
                        style="padding-top: 3px"
                    >
                        <el-radio
                            v-for="(option, index) in queData.AnswerList"
                            :key="index"
                            :label="String.fromCharCode(65 + index)"
                            >{{ String.fromCharCode(65 + index) }}</el-radio
                        >
                    </el-radio-group>
                    <el-checkbox-group
                        v-if="queType === 2"
                        v-model="queData.Answer"
                    >
                        <el-checkbox
                            v-for="(option, index) in queData.AnswerList"
                            :key="index"
                            :label="String.fromCharCode(65 + index)"
                        ></el-checkbox>
                    </el-checkbox-group>
                </div>
                <el-button
                    class="btn"
                    type="primary"
                    style="margin-left: 50px"
                    @click="addNewRow"
                >
                    添加选项 +
                </el-button>
            </div>
        </div>
        <div v-if="queType === SubjectType.fill">
            <div
                class="row xy-start"
                v-for="(option, index) in queData.AnswerList"
                :key="option.uuid"
            >
                <div class="row-title">填空{{ index + 1 }}:</div>

                <varied-input
                    ref="content"
                    class="auto-grow"
                    key="2"
                    :input-content.sync="option.Content"
                ></varied-input>
                <div
                    @click="deleteOption(index)"
                    :class="{ 'vis-hidden': queData.AnswerList.length === 1 }"
                    class="box el-icon-close delete-icon"
                ></div>
            </div>
            <div class="row xy-start">
                <div class="row-title"></div>
                <el-button class="btn" type="primary" @click="addNewRow">
                    添加选项 +
                </el-button>
            </div>
        </div>
        <div v-if="queType === 4">
            <div
                class="xy-center jf-start row"
                v-for="option in 2"
                :key="option"
            >
                <div class="row-title">
                    选项{{ String.fromCharCode(64 + option) }}:
                </div>

                <span class="font-size16">{{
                    option === 1 ? "正确" : "错误"
                }}</span>
            </div>
            <div class="xy-center jf-start row">
                <div class="row-title">正确答案:</div>
                <el-radio-group
                    v-model="queData.Answer"
                    style="padding-top: 3px"
                >
                    <el-radio
                        v-for="(option, index) in queData.AnswerList"
                        :key="index"
                        :label="String.fromCharCode(65 + index)"
                        >{{ String.fromCharCode(65 + index) }}</el-radio
                    >
                </el-radio-group>
            </div>
        </div>
        <div v-if="queType === 5 && queData.AnswerList" class="analysis xy-start row">
            <div class="row-title">答案:</div>
            <varied-input
                ref="content"
                :input-content.sync="queData.AnswerList[0].Content"
                class="auto-grow"
            ></varied-input>
            <div class="box"></div>
        </div>
        <div class="analysis xy-start row">
            <div class="row-title">解析:</div>
            <varied-input
                ref="analysisInput"
                :input-content.sync="queData.Analysis"
                class="auto-grow"
            ></varied-input>
            <div class="box"></div>
        </div>
    </div>
</template>
<script>
import variedInput from "@/components/manager/resource/VariedInput.vue";
import { CommonPage } from "@/mixins/commonData";
import { uuid } from "@/utils";
import { SubjectType } from "@/kernel";
export default {
    mixins: [CommonPage],
    components: { variedInput },
    props: {
        queType: {
            type: Number,
            default: 5,
        },
        editQueData: {
            type: Object,
            default: () => {},
        },
        isNew: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        window.dd = this.initQueData
        if (this.isNew) {
            this.initQueData();
        } else {
            this.queData = JSON.parse(JSON.stringify(this.editQueData));
            this.findRightAnswer();
        }
    },
    data() {
        return {
            queData: {},
        };
    },
    computed: {
        SubjectType() {
            return SubjectType;
        }
    },
    watch: {
        queType() {
            if (this.isNew) {
                this.initQueData();
            }
        },
        editQueData(data) {
            this.queData = data;
            this.findRightAnswer();
        },
        "queData.Answer"(value) {
            if (this.queType === 1 || this.queType === 4) {
                this.queData.AnswerList.map((item) => {
                    item.IsRight =
                        String.fromCharCode(item.RankNum + 64) === value
                            ? 1
                            : 0;
                });
            }
            if (this.queType === 2) {
                this.queData.AnswerList.map((item) => {
                    item.IsRight = value.includes(
                        String.fromCharCode(item.RankNum + 64)
                    )
                        ? 1
                        : 0;
                });
            }
        },
    },
    methods: {
        uuid,
        cleanInputs() {
            this.$refs.question && this.$refs.question.cleanContent()
            this.$refs.analysisInput && this.$refs.analysisInput.cleanContent()

            if (Array.isArray(this.$refs.content)) {
                this.$refs.content.forEach(ref => ref.cleanContent())
            } else {
                this.$refs.content && this.$refs.content.cleanContent();
            }
        },
        initQueData() {
            const commonKey = {
                Content: "",
                Analysis: "",
                Answer: "",
                SubjectType: this.queType,
            };
            this.cleanInputs()
            if (this.queType === 1 || this.queType === 2) {
                this.queData = {
                    ...commonKey,
                    Answer: this.queType === 1 ? "" : [],
                    AnswerList: [
                        {
                            Content: "",
                            RankNum: 1,
                            IsRight: 0,
                            uuid: this.uuid(5)
                        },
                        {
                            Content: "",
                            RankNum: 2,
                            IsRight: 0,
                            uuid: this.uuid(5)
                        },
                    ],
                };
            } else if (this.queType === 3) {
                this.queData = {
                    ...commonKey,
                    AnswerList: [
                        {
                            Content: "",
                            IsRight: 1,
                            uuid: this.uuid(5)
                        },
                        {
                            Content: "",
                            IsRight: 1,
                            uuid: this.uuid(5)
                        },
                    ],
                };
            } else if (this.queType === 4) {
                this.queData = {
                    ...commonKey,
                    AnswerList: [
                        {
                            Content: "正确",
                            IsRight: 1,
                            uuid: this.uuid(5),
                            RankNum: 1
                        },
                        {
                            Content: "错误",
                            IsRight: 0,
                            uuid: this.uuid(5),
                            RankNum: 2
                        },
                    ],
                };
            } else if (this.queType === 5) {
                this.queData = {
                    ...commonKey,
                    AnswerList: [
                        {
                            Content: "",
                            IsRight: 1,
                            uuid: this.uuid(5)
                        }
                    ],
                };
            }
        },
        // 重新设置序号
        resetRankNum(list) {
            list.forEach((e, i) => {
                e.RankNum = i + 1;
            })
        },
        addNewRow() {
            if ([1, 2].includes(this.queType)) {
                this.queData.AnswerList.push({
                    Content: "",
                    RankNum: this.queData.AnswerList.length + 1,
                    IsRight: 0,
                    uuid: this.uuid(5),
                    AnswerId: "",
                    SubjectId: this.queData.ParentId || ""
                });
            } else if (this.queType === 3) {
                this.queData.AnswerList.push({
                    Content: "",
                    RankNum: this.queData.AnswerList.length,
                    IsRight: 1,
                    uuid: this.uuid(5),
                    AnswerId: "",
                    SubjectId: this.queData.ParentId || ""
                });
            }
            this.resetRankNum(this.queData.AnswerList)
        },
        deleteOption(index) {
            console.log(index)
            this.queData.AnswerList.splice(index, 1);
            if (this.queType === 2) {
                // 多选题是数组
                this.queData.Answer = []
            } else {
                this.queData.Answer = ""
            }
            this.resetRankNum(this.queData.AnswerList)
        },
        findRightAnswer() {
            if (!this.queData.AnswerList) return;
            const arr = this.queData.AnswerList.filter(
                (item) => item.IsRight === 1
            ).map((item) => String.fromCharCode(64 + item.RankNum));
            // console.log("arr:", arr);
            if (this.queType === 1 || this.queType === 4) {
                this.queData.Answer = arr.join("");
            } else if (this.queType === 2) {
                this.queData.Answer = arr;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.add-que-box {
    .row {
        margin-top: 25px;

        .btn {
            width: 100px;
            height: 36px;
            padding: 0;
            border-radius: 4px;
        }
        .delete-icon {
            font-size: 16px;
            line-height: 36px;
            text-align: center;
        }
        .delete-icon:hover {
            font-weight: bold;
            color: #0c95fd;
        }
    }
    .row-title {
        font-size: 16px;
        white-space: nowrap;
        min-width: 5em;
        text-align: right;
        margin-right: 7px;
    }
    .box {
        width: 50px;
        min-width: 50px;
        height: 36px;
    }
}
</style>
